import { render, staticRenderFns } from "./downstreamCollectionIndex.vue?vue&type=template&id=937dfa42&scoped=true"
import script from "./downstreamCollectionIndex.vue?vue&type=script&lang=js"
export * from "./downstreamCollectionIndex.vue?vue&type=script&lang=js"
import style0 from "./downstreamCollectionIndex.vue?vue&type=style&index=0&id=937dfa42&prod&scoped=true&lang=css"
import style1 from "./downstreamCollectionIndex.vue?vue&type=style&index=1&id=937dfa42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937dfa42",
  null
  
)

export default component.exports